import {isTruthy} from "../../../Utility/logic";

/**
 * Informs the customer that the agent has marked it tax exempt. Right sidebar.
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function PayLaterIndicator({shoppingCart={}}) {
  let payLater = isTruthy(shoppingCart.properties?.payLater);

  if (!payLater) return null;

  return <div className="text-center">
    <span className="fas fa-credit-card text-green-800 mx-2"/>
    Pay Later, after items are confirmed
  </div>
}
